import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "src/componets/PageHeader";
import Filter from "src/componets/Filter";
import NavBarThree from "src/componets/NavBarThree";
import Wrapper from "src/componets/Wrapper";

import { useAppDispatch } from "src/store/hooks";
import { setNewParams } from "src/store/gh_market/bundlesSlice";
import { fetchBundles } from "src/actions/gh_market/bundlesActions";
import { queryParams } from "src/helpers/UrlHelpers";

import ListTable from "./_partials/_ListTable";
import New from "./New";
import Edit from "./Edit";

const LIMIT = 42;

const Bundles: React.FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;

  useEffect(() => {
    const params = queryParams.requestParams(
      searchParams,
      { limit: LIMIT, offset: (currentPage - 1) * LIMIT },
      ['term', 'order_by', 'order'],
      { 'order_by': 'id' }
    );

    dispatch(fetchBundles(params));
  }, [searchParams, currentPage, dispatch]);

  function onClickCreate() {
    dispatch(setNewParams({ platform: 'ios' }));
  }

  return (
    <PageLayout className='v-bundles'>
      <PageHeader title='Bundles' />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button onClick={onClickCreate}>
            <PlusOutlined /> Create Bundle
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            orderBy={{
              defaultKey: 'id',
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Name', key: 'name' },
                { name: 'Platform', key: 'platform' },
              ]
            }}
          />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Bundles;
